import React from 'react';
import { IRouteProps } from '../../../types';
import useGetHeaderLogo from './useGetHeaderLogo';
import { useGlobalState } from '../../../state/persistence';
import type { EntrypointProps } from '../Entrypoint';
const usePureApp = ({ defaultRoute }: EntrypointProps) => {
  const { appStore } = useGlobalState();

  const getRouteComponent = (route: IRouteProps) => {
    const $component = route.component;
    const { nextUrl, progress, flow } = route as IRouteProps;

    return React.createElement($component!, {
      key: `route-component-${route.path}`,
      nextUrl,
      progress,
      flow,
    });
  };

  const defaultRouteWithPublicUrl = `${process.env.REACT_APP_ORDER_URL}${defaultRoute}`;

  const logoOnClick = () => window.location.assign(defaultRoute ? defaultRouteWithPublicUrl : '/');

  return {
    getRouteComponent,
    logoOnClick,
    headerLogo: useGetHeaderLogo(),
    appStore,
  };
};

export default usePureApp;
